/* eslint-disable */
import { normalizeOptionalText } from "utils/personOptionalFields";
import ClientNameButton from "layouts/person/ClientNameButton";

const displayCell = (value) => normalizeOptionalText(value) ?? "-";

export default function inactivePersonTableData({ persons, onToggle, expandedPersonId }) {
  return {
    columns: [
      { Header: "Nombre", accessor: "Name", align: "left" },
      { Header: "Contacto", accessor: "Contact", align: "left" },
      { Header: "Ciudad", accessor: "City", align: "left" },
    ],
    rows: (persons || []).map((p) => ({
      _person: p,
      Name: (
        <ClientNameButton
          person={p}
          expanded={expandedPersonId === p.Id}
          onToggle={onToggle}
        />
      ),
      Contact: displayCell(p.Contact),
      City: `${displayCell(p.Department)} · ${displayCell(p.City)}`,
    })),
  };
}
